import React from 'react';
import '../../styles/TextWithButton.css'; // Ensure this CSS file is imported

type TextWithButtonProps = {
  text?: string;
  fontSize?: string;
  fontWeight?: number | string;
  lineHeight?: string;
  color?: string;
  textAlign?: 'left' | 'center' | 'right' | 'justify';
  style?: React.CSSProperties;
  showButton?: boolean;
  buttonLabel?: string;
  onButtonClick?: () => void;
};

const TextWithButton: React.FC<TextWithButtonProps> = ({
  text = 'ChatAssistant',
  fontSize = '32px',
  fontWeight = 700,
  lineHeight = '38px',
  color = '#030303',
  textAlign = 'right',
  style = {},
  showButton = false,
  buttonLabel = 'Click',
  onButtonClick,
}) => {
  const combinedStyles: React.CSSProperties = {
    fontFamily: 'Montserrat',
    fontSize,
    fontWeight,
    lineHeight,
    color,
    textAlign,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
    ...style,
  };

  return (
    <div className="responsive-text" style={combinedStyles}>
      <span>{text}</span>
      {showButton && (
        <button className="clear-inline-button" onClick={onButtonClick}>
          {buttonLabel}
        </button>
      )}
    </div>
  );
};

export default TextWithButton;
